import "./AboutUs.css";
import Header from "../../components/header";

const About = () => {
  return (
    <>
      <Header  hideSearchBar={true} />
      <div className="aboutus-container">
        <div className="aboutus-content">
          <h1 className="aboutus-title">About Us</h1>
          <p className="aboutus-intro">
            <strong>Welcome to Axionnest</strong> — a platform built to empower
            researchers, scholars, and academic enthusiasts. We make publishing
            and discovering research simple, engaging, and accessible to
            everyone.
          </p>

          <h2 className="aboutus-subtitle">Our Mission</h2>
          <p>
            At Axionnest, our goal is to foster a global, collaborative
            environment where ideas can be shared freely, and innovation can
            thrive. Whether you are a student, a researcher, or an institution,
            we provide tools to share your work, gain visibility, and connect
            with like-minded professionals.
          </p>

          <h2 className="aboutus-subtitle">What We Offer</h2>
          <ul className="aboutus-list">
            <li>
              📚 <strong>Easy Publishing:</strong> Upload theses, journals,
              chapters, images, or ideas in just a few clicks.
            </li>
            <li>
              🔍 <strong>Smart Search:</strong> Find content by title, keyword,
              author, or type — fast and efficiently.
            </li>
            <li>
              👥 <strong>Engaged Community:</strong> Follow authors, react to
              content, and stay connected with trending discussions.
            </li>
            <li>
              📈 <strong>Live Insights:</strong> Track reads and user engagement
              to see the impact of your research.
            </li>
          </ul>

          <h2 className="aboutus-subtitle">Why Axionnest?</h2>
          <p>
            We bridge the gap between traditional publishing and modern
            collaboration. Axionnest is the new home for researchers who value
            visibility, community, and simplicity.
          </p>

          <p className="aboutus-closing">
            Join us in building a smarter, more connected future for research.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
